import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import isClinical from "../../../../common/helpers/isPortal";
import GeneIcon from "../../../icons/Gene";
import {
  getCurrentUserSsoId,
  getThreadSelector,
} from "../../../../state/selectors/general.selectors";
import Btn from "../../../atoms/Btn";

function LinkVariantButton({ onSelect, isActive, showLabel, className, size }) {
  const isHidden = isClinical();

  const colorClass = isActive
    ? "tw-text-blue-500"
    : "tw-opacity-70 hover:tw-opacity-100";

  return isHidden ? null : (
    <div
      className={`tw-text-center tw-flex tw-items-center tw-relative ${colorClass}`}
    >
      <Btn onSubmit={onSelect} className="tw-flex tw-items-center">
        <div
          className={`${className} tw-flex tw-items-center tw-justify-center tw-relative tw-transition-colors tw-duration-300`}
        >
          <GeneIcon size={size} className="tw-fill-current" />
        </div>
        <div className="tw-w-0.5" />
        {showLabel ? <div>Link and Classify Variant</div> : null}
      </Btn>
    </div>
  );
}

LinkVariantButton.propTypes = {
  isActive: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  showLabel: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.number,
};

LinkVariantButton.defaultProps = {
  isActive: false,
  showLabel: true,
  className: "",
  size: 14,
};

const mapStateToProps = (state, { slug }) => {
  return {
    count: getThreadSelector(state, slug)?.count,
    ssoId: getCurrentUserSsoId(state),
    slug,
  };
};

export default React.memo(connect(mapStateToProps, {})(LinkVariantButton));
